"use strict";

/**
 * Open popunder on the clicks if the requirements are met
 * @method FlixPop.getPopUrl()
 * @method FlixPop.isEnabled()
 */
var FlixPop = function () {
  // Call "onPageLoad" when page loaded and "Flix" object prepared
  document.addEventListener('flix:load', onPageLoad);

  /**
   * If event listeners already initialized
   */
  var initialized = false;
  var stopCookie = 'popunder_stop';
  /**
   * sessionStorage key
   */
  var stopSessionKey = 'popunder_session_stop';

  /**
   * Main config thingy - popunder url
   * @returns string
   */
  function getPopUrl() {
    if (Flix.isTna()) {
      if (FlixUtils.isMobile()) {
        return "https://ad.twinrdengine.com/adraw?zone=01DXF6DT004000000000001ASZ&kw=".concat(Flix.ads.tags, "&tid=").concat(Flix.ads.iid);
      } else {
        return "https://ad.twinrdengine.com/adraw?zone=01DXF6DT0040000000000019Q0&kw=".concat(Flix.ads.tags, "&tid=").concat(Flix.ads.iid);
      }
    } else {
      if (FlixUtils.isMobile()) {
        return "https://ad.twinrdengine.com/adraw?zone=01DXF6DT004000000000001ASX&kw=".concat(Flix.ads.tags, "&tid=").concat(Flix.ads.iid);
      } else {
        return "https://ad.twinrdengine.com/adraw?zone=01DXF6DT0040000000000019Q6&kw=".concat(Flix.ads.tags, "&tid=").concat(Flix.ads.iid);
      }
    }
  }
  ;

  /**
   * Check if this ad should be shown.
   * As API method, because it's used in other places as well
   * @returns boolean
   */
  function isEnabled() {
    return Flix.ads.enabled
    // Do not trigger on chrome
    && (!FlixUtils.isChrome() || Flix.ads.wild)
    /** once per 6 hours for organic and on every visit for mediabuy */ && (Flix.ads.isOrganic()
    /** No pop cookie for organic user */ ? !FlixUtils.hasCookie(stopCookie)
    /** New session for mediabuy */ : !sessionStorage.getItem(stopSessionKey)) && !(Flix.site == 'empflix' && Flix.ads.iid == 1); // disable for alexz on emp
  }

  /**
   * Main logic
   */
  function onPageLoad() {
    if (!isEnabled() || initialized) {
      return;
    }
    initialized = true;
    document.addEventListener('click', onClick, true);
  }
  ;

  /**
   * Handle click event and trigger popunder if needed
   * @param {Event} e
   */
  function onClick(e) {
    var _a_element$attributes;
    /** To prevent duplicate pops. For example when user have several tabs */
    if (!isEnabled()) {
      return;
    }
    var a_element = e.target.closest('a');
    if (/** Click only on the <a> or video or preroll */
    !(a_element || e.target.closest('#video-player-container') || e.target.closest('#preroll-container'))
    /** Do not trigger popunder on the "target=_blank" links */ || (a_element === null || a_element === void 0 || (_a_element$attributes = a_element.attributes) === null || _a_element$attributes === void 0 || (_a_element$attributes = _a_element$attributes.target) === null || _a_element$attributes === void 0 ? void 0 : _a_element$attributes.value) == '_blank' || a_element !== null && a_element !== void 0 && a_element.getAttribute('data-modal') || a_element !== null && a_element !== void 0 && a_element.getAttribute('data-method') || a_element !== null && a_element !== void 0 && a_element.classList.contains('btn')) {
      return;
    }
    e.preventDefault ? e.preventDefault() : e.returnValue = false;
    e.stopPropagation();

    /** Cleanup */
    document.removeEventListener('click', onClick, true);

    /** This is where user wants to go */
    var targetUrl = a_element === null || a_element === void 0 ? void 0 : a_element.href;

    /** Open same page if links href is empty (e.g video player click) */
    if (!targetUrl || targetUrl == '#') {
      targetUrl = window.location.href;

      // /** Add video auto-play param, so video will start playing in the new active tab */
      // if (targetUrl.indexOf('play=1') == -1) {
      //     targetUrl += (targetUrl.indexOf('?') == -1 ? '?' : '&') + 'play=1';
      // }
    }

    // This is used in fpi.js to prevent showing interstitial after clicking play button
    targetUrl += (targetUrl.indexOf('?') == -1 ? '?' : '&') + 'from_pop=1';
    FlixUtils.setCookie(stopCookie, 1, 1 / 4);
    sessionStorage.setItem(stopSessionKey, 1);

    // To open fpi together with pop
    sessionStorage.setItem(FlixFpi.sessionAfterPopKey, 1);
    setTimeout(function () {
      return window.location.href = getPopUrl();
    }, 500);
    window.open(targetUrl);
  }
  ;
  return {
    getPopUrl: getPopUrl,
    isEnabled: isEnabled
  };
}();